import React, { Component } from "react";
import "react-comun-seps/lib/assets/theme/theme-blue-v4.css";
import "react-comun-seps/lib/assets/layout/css/layout-blue-v4.css";
import "primereact/resources/primereact.min.css";
import "fullcalendar/dist/fullcalendar.css";
import "font-awesome/css/font-awesome.css";
import "primeicons/primeicons.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.css";

import { Router, Route, Switch } from "react-router-dom";
import { captchaSettings } from "reactjs-captcha";
import { connect } from "react-redux";
import { history } from "./helpers/history";
import { alertActions } from "./acciones/alertActions";
import { PrivateRoute } from "react-comun-seps/lib/components/PrivateRoute";
//import { PrivateRoute } from './componentes/PrivateRoute';
import { LoginPage } from "./componentes/LoginPage";
import { RecuperarclavePage } from "./componentes/RecuperarclavePage";
import { AcuerdosContainer } from "./containers/AcuerdosContainer";
import { SistemasContainer } from "./containers/SistemasContainer";
import { OrganizacionesContainer } from "./containers/OrganizacionesContainer";
import { datosLocalesHelper } from "react-comun-seps/lib/helpers/datosLocalesHelper";
import { ApiRest } from "react-comun-seps/lib/api/ApiRest";
import { claveNuevaComponent } from "./componentes/claveNuevaComponent";

import { CAPTCHA_HOST } from "node-constantes-seps";

class App extends Component {
  constructor(props) {
    super(props);
    const { dispatch } = this.props;
    history.listen((location, action) => {
      dispatch(alertActions.clear());
    });
    captchaSettings.set({
      captchaEndpoint: `${CAPTCHA_HOST}/botdetect-captcha-lib/simple-botdetect.php`,
    });
  }

  render() {
    let datosLocales = datosLocalesHelper();
    return (
      <Router history={history}>
        <Switch>
          {datosLocales && datosLocales.sistemaSeps && (
            <PrivateRoute
              exact
              path="/inicio"
              component={() => {
                window.location = `${window.location.protocol}//${
                  datosLocales.sistemaSeps.url
                }/inicio?id=${ApiRest.obtenerDatoLocal(
                  "tokenSeps"
                )}&data=${btoa(encodeURI(JSON.stringify(datosLocales)))}`;
                return null;
              }}
            />
          )}
          <PrivateRoute exact path="/sistemas" component={SistemasContainer} />
          <PrivateRoute exact path="/acuerdos" component={AcuerdosContainer} />
          <PrivateRoute
            exact
            path="/organizaciones"
            component={OrganizacionesContainer}
          />
          <Route exact path="/" component={LoginPage} />
          <Route exact path="/login" component={LoginPage} />
          <Route path="/recuperarclave" component={RecuperarclavePage} />
          <Route path="/claveNuevaComponent" component={claveNuevaComponent} />
        </Switch>
      </Router>
    );
  }
}

function mapStateToProps(state) {
  const { alert } = state;
  return {
    alert,
  };
}

const connectedApp = connect(mapStateToProps)(App);
export { connectedApp as App };
